/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinqrshortlink3Inputs */

const en_checkinqrshortlink3 = /** @type {(inputs: Checkinqrshortlink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const de_checkinqrshortlink3 = /** @type {(inputs: Checkinqrshortlink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

/**
* | output |
* | --- |
* | "Link" |
*
* @param {Checkinqrshortlink3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinqrshortlink3 = /** @type {((inputs?: Checkinqrshortlink3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinqrshortlink3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinqrshortlink3(inputs)
	return de_checkinqrshortlink3(inputs)
});
export { checkinqrshortlink3 as "checkinQrShortLink" }